<template>
    <TermsCheck
        :content="listText"
        :is-loading="isLoading"
        @goNext="goNext"
    />
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAgreeTermsB4, postAgreeB4 } from '@/apis/B4';
import routeName from '@/router/constant.js';
import TermsCheck from '@/components/template/TermsCheck.vue';

export default {
    components: {
        TermsCheck
    },
    setup() {
        const router = useRouter();
        const listText = ref('');
        const isLoading = ref(false);
        /** 取得條款內容 */
        getAgreeTermsB4().then((res) => {
            listText.value = res.data.agreeTerms.content;
        });

        const goNext = () => {
            isLoading.value = true;
            postAgreeB4().then(() => {
                router.push({
                    name: routeName.ENOTIFY
                });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            listText,
            isLoading,
            goNext
        };
    },
};
</script>

<style>
</style>
